export default (function () {
  return {
    // there's no Software impression event, so don't log impressions
    logImpression: false,
    text: 'Shop Now'
  };
});